<template>
	<div class="row q-col-gutter-lg">
		<div id="circularProgressContainer">
			<CircularProgress />			
		</div>
		<div class="col-xs-8" id="pageTitleContainer">
			<div class="text-h4 text-weight-bold" id="pageTitle">{{ $t(title) }}</div>
			<div v-if="description" class="q-py-xs" id="pageDescription">{{ $t(description) }}</div>
		</div>
	</div>
	<q-separator class="q-my-md" id="separator" />
	<div class="q-py-xs" id="pageContent"><span v-html="$t(content)"></span></div>
	<q-option-group
		id="radioBtnOptionGroup"
		:options="[{ label: $t('portal_btnAgree'), value: true }, { label: $t('portal_btnDisagree'), value: false }]"
		type="radio"
		v-model="portal.dataPolicyAgreed"
	/>
</template>

<style lang="less" scoped src="./data-policy.less"></style>
<script lang="ts" src="./data-policy.ts"></script>
